<script setup lang="ts">
import { ref } from 'vue';
import Editor from '../../General/Editor.vue';
import { useLectureStore, useSessionStore, useSignalRStore } from '../../../stores';
import { Session } from '../../../types/session';
import Button from '../../General/Button.vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../configs/text';
import Heading from '../../General/Heading.vue';
import IclassLecture from './iclass/IclassLecture.vue';
import Modal from '../../General/Modal.vue';
import Iframe from '../../General/Iframe.vue';
import { utils } from '../../../utils';
import { EyeIcon } from '@heroicons/vue/24/outline';

const signalr = useSignalRStore()
const sessionStore = useSessionStore()
const lecture = useLectureStore()
const questionContent = ref<string>(sessionStore.classContent?.[Session.lecture].questionUrl || '')
const modalShow = ref<boolean>(false)

function handleSaveLectureQuestion() {
    signalr.updateLectureQuestion(questionContent.value)
}

const { t } = useI18n()
</script>

<template>
    <IclassLecture v-if="lecture.questions?.length" />

    <template v-else-if="typeof questionContent !== 'undefined' && questionContent !== null">
        <Heading class="mr-auto mt-2 first-letter:capitalize">
            {{ t(TEXT.question) }}
            <EyeIcon class="inline size-5 text-gray-500 ml-1 cursor-pointer" @click="modalShow = true" />
        </Heading>
        <div class="w-full prose max-w-none prose-p:my-4 prose-p:leading-6 overflow-auto">
            <Editor v-model="questionContent" />
        </div>
        <Button color="warning" @click="handleSaveLectureQuestion">{{ t(TEXT.save) }}</Button>

        <Modal v-model="modalShow" size="full" :full-height="true">
            <Iframe v-if="utils.isValidUrl(utils.stripHtmlTags(questionContent))"
                :src="utils.decodeHtmlEntities(utils.stripHtmlTags(questionContent))" orientation="full" />
            <div v-else v-html="questionContent"
                class="prose max-w-none w-full prose-p:my-4 prose-p:leading-6 ck-content border-2 border-gray-200 rounded-lg px-3 md:px-6 overflow-auto">
            </div>
        </Modal>
    </template>
</template>